var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-top"}),_c('p',{staticClass:"modal-tip"},[_vm._v("阅读快音的消息推送就有金币送哦～")]),_c('div',{staticClass:"modal-button",on:{"click":_vm.handleBtn}},[_vm._v("我知道了")])])}
var staticRenderFns = []

export { render, staticRenderFns }